import React from "react";

import { twMerge } from "tailwind-merge";

type Props = React.HTMLProps<HTMLAnchorElement> & {
  href: string;
  ref?: React.Ref<HTMLAnchorElement>;
};

export const ExternalLink: React.FC<Props> = ({
  className,
  href,
  children,
  ref,
  ...props
}) => (
  <a
    ref={ref}
    className={twMerge("text-indigo-600", className)}
    href={href}
    rel="noreferrer noopener"
    target="_blank"
    {...props}
  >
    {children}
  </a>
);
